import React, {ReactElement} from "react";
import {ConditionalFormType} from "/src/types";

import SimpleForm from "../../simple-form/SimpleForm";
import {LOCALE} from "/src/config";

const OverhaulSignUpStep2Form = (props: ConditionalFormType): ReactElement => {
  const {...simpleFormProps} = props;

  // eslint-disable-next-line  @typescript-eslint/no-unused-vars
  const updateConditionState = (fieldName: string, val: string) => {
    // do nothing
  };

  const isInvisible = (fieldName: string) => {
    if (fieldName === "Signup_Incoterms" && LOCALE !== "zh-CN") {
      return true;
    }
    return false;
  };

  return (
    <SimpleForm
      {...simpleFormProps}
      updateConditionState={updateConditionState}
      isInvisible={isInvisible}
    />
  );
};

export default OverhaulSignUpStep2Form;
